import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { MDBRow, MDBCol } from 'mdbreact';

import Toast from 'components/Informations/Toast';
import Page from 'components/PageStructure';

import DateField from 'components/FormGroup/DateField';
import SelectField from 'components/FormGroup/SelectField';

import endpoints from 'services/endpoints';

import useFetch from 'hooks/useFetch';

import { ArrUniq } from 'utils/core';
import { filterData } from './utils';

import RefundsActions from './InternalComponents/RefundsActions';
import RefundsTable from './InternalComponents/RefundsTable';

import * as S from './styles';

const status = [
  { value: 1, label: 'Pendente' },
  { value: 2, label: 'Aprovado' },
  { value: 3, label: 'Recusado' },
  { value: 4, label: 'Em análise' },
  { value: 5, label: 'Enviado ao faturamento' },
];

const { getRefundsInfoToProjectManager, approveRefund } = endpoints;

export default function AproveRefunds({ user }) {
  const { id_funcionario: userID } = user;

  const html = document.querySelector('html');

  const [dataTable, setDataTable] = useState();
  const [month, setMonth] = useState();

  const [projectsOpts, setProjectOpts] = useState([]);
  const [employeeOpts, setEmployeeOpts] = useState([]);

  const [modalData, setModalData] = useState();
  const [reloadData, setReloadData] = useState(false);
  const [modalState, setModalState] = useState(true);

  const [statusOpts, setStatusOpts] = useState([]);

  const [choosenStatus, setChoosenStatus] = useState();
  const [choosenProject, setChoosenProject] = useState();
  const [choosenEmployee, setChoosenEmployee] = useState();

  const [toastType, setToastType] = useState('');
  const [toastMessage, setToastMessage] = useState('');
  const [toastClose, setToastClose] = useState(2000);
  const [toastVisibility, setToastVisibility] = useState(false);

  const [refundsToApprove] = useFetch(
    `${getRefundsInfoToProjectManager}/${userID}`,
    reloadData
  );

  useEffect(() => {
    (async () => {
      const data = await refundsToApprove;
      const reset = { value: '', label: 'Limpar Filtro' };

      const filteredData = data?.filter(
        filterData(choosenEmployee, choosenProject, choosenStatus, month)
      );

      const employeeList = data?.map(employee => ({
        label: employee.nome_funcionario,
        value: employee.id_funcionario,
      }));

      const projectsList = data?.map(project => ({
        label: project.nome_projeto,
        value: project.id_projeto,
      }));

      const employeeOptions = ArrUniq(employeeList, o => o.label);
      const projectsOptions = ArrUniq(projectsList, o => o.label);

      setProjectOpts(
        choosenProject ? [reset, ...projectsOptions] : projectsOptions
      );
      setEmployeeOpts(
        choosenEmployee ? [reset, ...employeeOptions] : employeeOptions
      );
      setStatusOpts(choosenStatus ? [reset, ...status] : status);
      setDataTable(filteredData);
    })();
  }, [month, choosenEmployee, choosenProject, choosenStatus, refundsToApprove]);

  const handleChooseStaus = e => setChoosenStatus(e.value);
  const handleChooseProject = e => setChoosenProject(e.value);
  const handleChooseEmployee = e => setChoosenEmployee(e.value);
  const clearModal = () => {
    html.style.overflow = 'auto';
    setModalState(false);
    setModalData();
  };

  const renderToast = (type, message, closeTime) => {
    const condition = closeTime !== undefined ? closeTime : toastClose;

    setToastVisibility(true);
    setToastMessage(message);
    setToastType(type);
    setToastClose(condition);
    setTimeout(() => {
      setToastVisibility(false);
      setToastMessage('');
      setToastType('');
    }, condition + 1500);
  };

  const openModal = () => {
    html.style.overflow = 'hidden';
    return (
      <RefundsActions
        paymentsData={{ userID, modalData }}
        clearModal={clearModal}
        reload={setReloadData}
        renderToast={renderToast}
        approveEndpoint={approveRefund}
      />
    );
  };

  return (
    <>
      {modalState && modalData && openModal()}
      {toastVisibility && (
        <Toast
          type={toastType}
          message={toastMessage}
          autoClose={toastClose}
          hideProgress
        />
      )}
      <Page
        title="Aprovar reembolsos"
        subtitle="Aqui você pode visualizar e atualizar as solicitações de reembolso dos seus projetos"
      >
        <MDBRow>
          <MDBCol>
            <S.ControllersWrap>
              <S.DateWrap>
                <DateField
                  onlyMonth
                  selectedValue={month}
                  handleChange={e => setMonth(e)}
                  name="filterDate"
                  id="filterDate"
                  className="w-100 date-to-approve"
                  isClearable
                  labelText="Selecione um mês"
                />
              </S.DateWrap>
              <S.InputsWrap>
                <SelectField
                  className="w-100"
                  labelText="Selecione um funcionário"
                  value={employeeOpts.find(
                    opt => opt.value === choosenEmployee
                  )}
                  options={employeeOpts}
                  handleChange={handleChooseEmployee}
                  hasSecondaryStyle
                  hasLabelMargin
                />
              </S.InputsWrap>
              <S.InputsWrap>
                <SelectField
                  className="w-100"
                  labelText="Selecione um projeto"
                  value={projectsOpts.find(opt => opt.value === choosenProject)}
                  options={projectsOpts}
                  handleChange={handleChooseProject}
                  hasSecondaryStyle
                  hasLabelMargin
                />
              </S.InputsWrap>
              <S.InputsWrap>
                <SelectField
                  className="w-100"
                  labelText="Status"
                  value={statusOpts.find(opt => opt.value === choosenStatus)}
                  handleChange={handleChooseStaus}
                  options={statusOpts}
                  hasSecondaryStyle
                  hasLabelMargin
                />
              </S.InputsWrap>
            </S.ControllersWrap>
          </MDBCol>
        </MDBRow>

        <MDBRow>
          <MDBCol>
            <RefundsTable
              data={dataTable}
              setModalState={setModalState}
              setModalData={setModalData}
            />
          </MDBCol>
        </MDBRow>
      </Page>
    </>
  );
}

AproveRefunds.propTypes = {
  user: PropTypes.shape(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool])
  ).isRequired,
};
